import api from "@/lib/axiosConfig.ts";
import { tabMenuItems } from "@/lib/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

async function getAllinstanceForAUser(userId: string | undefined) {
  const { data } = await api.get("back/api/user/instance/" + userId);
  return data;
}

export const useGetAllinstanceForAUser = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["instance", userId],
    queryFn: () => getAllinstanceForAUser(userId),
    enabled: !!userId,
  });
};

async function getInstance(instanceName: string | undefined) {
  const { data } = await api.get("back/api/instance/" + instanceName);
  return data;
}

export const useGetInstance = (instanceName: string | undefined) => {
  return useQuery({
    queryKey: ["instance", instanceName],
    queryFn: () => getInstance(instanceName),
    placeholderData: keepPreviousData,
    enabled: !!instanceName,
  });
};

export type CountData = {
  [key in (typeof tabMenuItems)[number]]: number;
};

async function countData(): Promise<CountData> {
  const { data } = await api.get("back/api/instance/count-data");
  return data;
}

export const useCountData = () => {
  return useQuery({
    queryKey: ["instance", "count-data"],
    queryFn: () => countData(),
  });
};
